export const SEARCH_WOOS_DELIVERY_POINTS = 'SEARCH_WOOS_DELIVERY_POINTS';
export const SEARCH_PUBLICS_DELIVERY_POINTS = 'SEARCH_PUBLICS_DELIVERY_POINTS';
export const SEARCH_PRIVATES_DELIVERY_POINTS = 'SEARCH_PRIVATES_DELIVERY_POINTS';
export const LOCATE_USER = 'LOCATE_USER';
export const FETCH_DELIVERY_POINT = 'FETCH_DELIVERY_POINT';
export const FETCH_PUBLIC_DELIVERY_POINTS = 'FETCH_PUBLIC_DELIVERY_POINTS';
export const RESET_MAP = 'RESET_MAP';
export const RESET_MAP_POSITION = 'RESET_MAP_POSITION';
export const SETUP_MAP = 'SETUP_MAP';
